import { doc, getDoc, serverTimestamp, setDoc } from 'firebase/firestore';
import { auth, db } from '../firebase';
import {
  CLOUD_COLLECTIONS,
  CONTROLLED_CLOUD_GRIND_TEST_MARKER,
  getControlledCloudGrindTestCampaignId,
  isControlledCloudGrindTestCampaignEnabled,
  isControlledPaidDiscoveryEnabled
} from './cloudSchema';

export function createControlledCloudGrindTestCampaignDraft({
  creatorId,
  creatorName = 'PromoGrind Test Creator'
}) {
  if (!creatorId) {
    throw new Error('creatorId is required for the controlled cloud Grind test campaign.');
  }

  return {
    source: 'cloud',
    localOriginId: CONTROLLED_CLOUD_GRIND_TEST_MARKER,
    legacy: {
      platform: '',
      creatorType: ''
    },
    creatorId,
    creatorName,
    creatorType: 'Controlled Test',
    platform: 'Book',
    targetInterestIds: ['readers'],
    completionTokenRate: 4,
    audienceMode: 'interests',
    title: 'PromoGrind Controlled Cloud Grind Test',
    message: 'Controlled cloud-only campaign for verifying shared Grinds. No tokens, payments, or completions are moved by this campaign.',
    visual: null,
    artwork: null,
    mediaLink: '',
    mediaPreview: null,
    destination: {
      type: 'amazon',
      url: 'https://www.amazon.com/'
    },
    learnMoreLink: '',
    learnMorePreview: null,
    feedbackQuestion: 'Did this controlled Grind test display correctly?',
    status: 'Active',
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp(),
    publishedAt: serverTimestamp()
  };
}

export async function createControlledCloudGrindTestCampaign() {
  if (!isControlledCloudGrindTestCampaignEnabled()) {
    throw new Error('Controlled cloud Grind test campaign mode is disabled.');
  }

  const creator = auth.currentUser;
  if (!creator?.uid) {
    throw new Error('Sign in as the test campaign creator first.');
  }

  const campaignRef = doc(
    db,
    CLOUD_COLLECTIONS.campaigns,
    getControlledCloudGrindTestCampaignId()
  );
  const draft = createControlledCloudGrindTestCampaignDraft({
    creatorId: creator.uid,
    creatorName: creator.displayName || creator.email || 'PromoGrind Test Creator'
  });

  await setDoc(campaignRef, draft);
  return {
    id: getControlledCloudGrindTestCampaignId(),
    ...draft
  };
}

export async function getControlledCloudGrindTestCampaign() {
  if (!isControlledPaidDiscoveryEnabled()) {
    return null;
  }

  const campaignRef = doc(
    db,
    CLOUD_COLLECTIONS.campaigns,
    getControlledCloudGrindTestCampaignId()
  );
  const snapshot = await getDoc(campaignRef);
  if (!snapshot.exists()) return null;

  return {
    id: snapshot.id,
    ...snapshot.data()
  };
}

if (typeof window !== 'undefined' && process.env.NODE_ENV !== 'production') {
  window.promoGrindCloudGrindTest = {
    createControlledCloudGrindTestCampaign,
    createControlledCloudGrindTestCampaignDraft,
    getControlledCloudGrindTestCampaign
  };
}
